import {CartSummaryModel} from '../models/checkout/CartSummary/CartSummary.model';
import {CheckoutSettingsModel} from '../models/checkout/checkoutSettings/CheckoutSettings.model';
import {ILocaleKeys} from '../../locale-keys/LocaleKeys';
import {CouponDiscountModel} from '../models/checkout/CartSummary/CouponDiscount.model';
import {TaxModel} from '../models/checkout/CartSummary/Tax.model';

export const isPartiallyPaid = (cartSummary: CartSummaryModel) => Boolean(cartSummary.paymentSummary.payLater?.amount);
export const hasFreeTrial = (cartSummary: CartSummaryModel) =>
  Boolean(cartSummary.paymentSummary.payAfterFreeTrial?.amount);

export const getTotal = (cartSummary: CartSummaryModel) =>
  !isPartiallyPaid(cartSummary) && !hasFreeTrial(cartSummary)
    ? cartSummary.paymentSummary.payNow.formattedAmount
    : cartSummary.paymentSummary.totalAfterGiftCards.formattedAmount;

export const getTaxName = ({
  taxName,
  checkoutSettings,
  localeKeys,
}: {
  taxName?: string;
  checkoutSettings: CheckoutSettingsModel;
  localeKeys: ILocaleKeys;
}): string => {
  return taxName || checkoutSettings.taxName || localeKeys.checkout.order_summary.totals.tax();
};

export const formatSignedAmount = ({amount, isRTL}: {amount: string; isRTL: boolean}): string => {
  return isRTL ? /* istanbul ignore next */ `${amount}-` : `-${amount}`;
};

export const isFreeShippingCoupon = (coupon: CouponDiscountModel): boolean => {
  return coupon.isFreeShippingCoupon;
};

export const isFullTaxExempt = (tax: TaxModel): boolean => tax.exemptAmount.amount > 0 && tax.amount.amount === 0;

export const isPartialTaxExempt = (tax: TaxModel): boolean => tax.exemptAmount.amount > 0 && tax.amount.amount > 0;

export const getTaxesWithSomeTaxExemption = (taxes: TaxModel[]) =>
  taxes.filter((tax) => isFullTaxExempt(tax) || isPartialTaxExempt(tax));
